/* eslint-disable */
export enum CurrencyFormat {
  SYMBOL = 'SYMBOL',
  SYMBOL_NARROW = 'SYMBOL_NARROW',
  SHORT_CODE = 'SHORT_CODE'
}

export const currencyFormatMap = {
  [CurrencyFormat.SHORT_CODE]: 'code',
  [CurrencyFormat.SYMBOL]: 'symbol',
  [CurrencyFormat.SYMBOL_NARROW]: 'symbol-narrow'
};
